<template>
  <div>
    <!-- 渲染表格 -->
    <BasicTable
      :isStyleApplied="isStyleApplied"
      searchPlaceholder="名称,型号,运营人,实名,持有人,厂商,主/备通道"
      :tableColumn="tableColumn"
      :tableData="tableData"
      :actions="actions"
      :showAddButton="uBtnPermissionList.includes('aircraft-add')"
      :showExportButton="uBtnPermissionList.includes('aircraft-export')"
      :showSearch="true"
      tableTitle="航空器管理"
      :current="current"
      :total="total"
      :size="size"
      @add-item="addItem"
      @detail-item="detailItem"
      @edit-item="editItem"
      @delete-item="deleteItem"
      @export-item="exportItem"
      @search-item="searchItem"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
<!--      <template #extraBtn="scope" >-->
<!--            <el-button v-if="uBtnPermissionList.includes('aircraft-approve')&&scope.row.status==0"  @click="approvalClick(scope.row)" type="text" size="small">审批</el-button>-->
<!--            &lt;!&ndash; 是否有驳回原因 &ndash;&gt;-->
<!--            <el-button  v-if="uBtnPermissionList.includes('aircraft-reject')&&scope.row.status==0" @click="rejectClick(scope.row)" type="text" size="small">驳回</el-button>-->
<!--      </template>-->
<!--      <template #customCol>-->
<!--        <el-table-column prop="status" label="状态" align="center" min-width="60" :show-overflow-tooltip="true">-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row.status === 0">待审批</span>-->
<!--            <span v-if="scope.row.status === 1">已审批</span>-->
<!--            <span v-if="scope.row.status === 2">已驳回</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--      </template>-->

    </BasicTable>
    <!-- 渲染弹框 -->
    <BasicForm
      :isStyleApplied="isStyleApplied"
      :dialogVisible="dialogVisible"
      :dialogTitle="dialogTitle"
      :formModel="taskForm"
      :btnName="btnName"
      @submit="handleFormSubmit"
      @update:dialogVisible="updateDialogVisible"
      :formRules="formRules"
    >
      <!-- 正常写本页面需要的表单项 -->
        <el-col :span="12">
          <el-form-item label="产品序列号" prop="productId">
            <el-input v-model="taskForm.productId" :disabled="ifView" placeholder="请填写产品序列号/出厂序号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实名登记" prop="verificationMark">
            <el-input v-model="taskForm.verificationMark" :disabled="ifView" placeholder="请填写实名登记标志"></el-input>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="12">
          <el-form-item label="持有人类型" prop="ownerTypeDTO">
            <el-select v-model="taskForm.ownerTypeDTO" :disabled="ifView" placeholder="请选择持有人类型">
              <el-option
                v-for="type in ownerTypeOptions"
                :key="type.value"
                :label="type.value"
                :value="type.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item label="持有人姓名" prop="ownerName">
            <el-input v-model="taskForm.ownerName" :disabled="ifView" placeholder="请填写持有人姓名"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="生产厂商" prop="manufacturer">
            <el-input v-model="taskForm.manufacturer" :disabled="ifView" placeholder="请填写生产厂商名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品型号" prop="productModel">
            <el-input v-model="taskForm.productModel" :disabled="ifView" placeholder="请填写产品型号"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="产品名称" prop="productName">
            <el-input v-model="taskForm.productName" :disabled="ifView" placeholder="请填写产品名称"></el-input>
          </el-form-item>
        </el-col>
      <el-col :span="12">
        <el-form-item label="产品简称" prop="simpleAircraftName">
          <el-input v-model="taskForm.simpleAircraftName" :disabled="ifView" placeholder="请填写产品名称" minlength="2" maxlength="4"></el-input>
        </el-form-item>
      </el-col>
        <el-col :span="12">
          <el-form-item label="产品类别" prop="productCategoryDTO">
            <el-select v-model="taskForm.productCategoryDTO" :disabled="ifView" placeholder="请选择产品类别">
              <el-option
                v-for="type in productCategoryDTOOptions"
                :key="type.value"
                :label="type.value"
                :value="type.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品类型" prop="productTypeDTO">
            <el-select v-model="taskForm.productTypeDTO" :disabled="ifView" placeholder="请选择产品类型">
              <el-option
                v-for="type in productTypeDTOOptions"
                :key="type.value"
                :label="type.value"
                :value="type.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="通信距离(km)"
            prop="comDistance"
            :rules="[{ required: true, message: '请填写通信距离(km)', trigger: 'blur' }, { validator: this.validateNumber, trigger: 'blur' }]"
          >
            <el-input v-model="taskForm.comDistance" :disabled="ifView" placeholder="请填写通信距离(km)"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            label="空机重量(kg)"
            prop="emptyWeight"
            :rules="[{ required: true, message: '请填写空机重量(kg)', trigger: 'blur' }, { validator: this.validateNumber, trigger: 'blur' }]"
          >
            <el-input v-model="taskForm.emptyWeight" :disabled="ifView" placeholder="请填写空机重量(kg)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="最大负载(kg)"
            prop="maxLoad"
            :rules="[{ required: true, message: '请填写最大负载(kg)', trigger: 'blur' }, { validator: this.validateNumber, trigger: 'blur' }]"
          >
            <el-input v-model="taskForm.maxLoad" :disabled="ifView" placeholder="请填写最大负载(kg)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="运营人名称" prop="operatorId">
            <el-select
              v-model="taskForm.operatorId"
              :disabled="ifView"
              placeholder="请选择运营人名称"
              filterable
              clearable
            >
              <el-option
                v-for="item in operatorNames"
                :key="item.id"
                :label="item.operatorName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主通道" prop="mainChannel">
            <el-input v-model="taskForm.mainChannel" :disabled="ifView" placeholder="请填写主通道"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备通道" prop="backupChannel">
            <el-input v-model="taskForm.backupChannel" :disabled="ifView" placeholder="请填写备通道"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="保险图片" :prop="ifView ? '' : 'pic'" label-width="180px" :disabled="ifView">
            <el-upload class="upload-demo" action="#" :auto-upload="false" :show-file-list="false"   accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,"
              :on-change="handleElementPicChange" :disabled="ifView">
              <el-image :preview-src-list="dialogTitle == '查看' ? [imageUrl] : []" v-if="imageUrl" :src="imageUrl" class="uploaded-image" :title="imgTitle"/>
              <div v-else class="upload-placeholder">
                <!-- <i class="el-icon-upload"></i> -->
                <div class="upload-text">
                  <span>去上传</span>
                </div>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
    </BasicForm>
  </div>
</template>
<script type="text/javascript">
import BasicTable from "../../common/BasicTable.vue";
import BasicForm from "../../common/BasicForm.vue";
import axios from "axios";
import { deepCopy } from '@/utils/tools.js'

export default {
  props: {
    isStyleApplied: {
      type: Boolean,
      default: false,
    },
  },
  name: "Aircraft",
  // 注入公共组件
  components: {
    BasicTable, //公共表格
    BasicForm, //公共弹框
  },
  data() {
    return {
      // ============表格配置信息==============
      // 列配置 label-列名，prop-对应列的字段名
      tableColumn: [
        { label: '产品序列号', prop: 'productId' },
        { label: '实名登记', prop: 'verificationMark' },
        // { label: '持有人类型', prop: 'ownerTypeDTO' },
        // { label: '持有人姓名', prop: 'ownerName' },
        { label: '生产厂商', prop: 'manufacturer' },
        { label: '产品型号', prop: 'productModel' },
        { label: '产品名称', prop: 'productName' },
        { label: '产品简称', prop: 'simpleAircraftName' },
        { label: '产品类别', prop: 'productCategoryDTO' },
        // { label: '产品类型', prop: 'productTypeDTO' },
        // { label: '空机重量(kg)', prop: 'emptyWeight' },
        // { label: '最大负载(kg)', prop: 'maxLoad' },
        // { label: '通信距离(km)', prop: 'comDistance' },
        { label: '运营人名称', prop: 'operatorName' },
        // { label: '主通道', prop: 'mainChannel' },
        // { label: '备通道', prop: 'backupChannel' },
      ],
      tableData: [], // 列表内容数据
      actions: [],
      showAddButton: true, //是否展示新增按钮
      showExportButton: true, //是否展示新增按钮

      // ===========表单配置信息===============
      dialogVisible: false, //初始不展示对话框
      dialogTitle: '', //表单标题
      btnName: '', //表单提交按钮名字
      taskForm: {
        id: '',
        simpleAircraftName: '',
        productId: '',
        verificationMark: '',
        ownerTypeDTO: '',
        ownerName: '',
        manufacturer: '',
        productModel: '',
        productName: '',
        productCategoryDTO: '',
        productTypeDTO: '',
        emptyWeight: '',
        maxLoad: '',
        comDistance: '',
        operatorId: '',
      }, // 表单数据绑定
      ifView: false, //是否为查看状态
      ownerTypeOptions: [
        { value: '个人' },
        { value: '单位' }
        // 可以根据实际情况添加更多的选项
      ],
      productCategoryDTOOptions: [
        { value: '微型' },
        { value: '轻型' },
        { value: '小型' },
        { value: '中型' },
        { value: '大型' },
        // 可以根据实际情况添加更多的选项
      ],
      productTypeDTOOptions: [
        { value: '固定翼' },
        { value: '旋翼航空器' },
        { value: '多桨或多轴航空器' },
        { value: '复合翼航空器' },
        { value: '飞艇' },
        { value: '其他' }
        // 可以根据实际情况添加更多的选项
      ],
      isFieldHidden: true, // 控制字段是否隐藏
      imageUrl: '',
      imgTitle: '',
      // 定义表单必填校验
      formRules: [
        { label: '产品序列号', prop: 'productId' },
        { label: '实名登记', prop: 'verificationMark' },
        // { label: '持有人类型', prop: 'ownerTypeDTO' },
        { label: '持有人姓名', prop: 'ownerName' },
        { label: '生产厂商', prop: 'manufacturer' },
        { label: '产品型号', prop: 'productModel' },
        { label: '产品名称', prop: 'productName' },
        { label: '产品类别', prop: 'productCategoryDTO' },
        { label: '产品类型', prop: 'productTypeDTO' },
        // { label: '通信距离(km)', prop: 'productId' },
        // { label: '空机重量(kg)', prop: 'productId' },
        // { label: '最大负载(kg)', prop: 'verificationMark' },
        { label: '运营人名称', prop: 'operatorId' },
        { label: '主通道', prop: 'mainChannel' },
        { label: '备通道', prop: 'backupChannel' },
      ],
      operatorNames: [], //运行人名称
      total: 0, //总条数
      current: 1, //当前页数
      size: 18, //显示几条
      searchKey: '', //搜索关键字
    };
  },
  mounted() {
    // 请求表格配置和数据
    this.$nextTick(function () {
      this.uBtnPermissionList.includes('aircraft-check')&&this.actions.push({ label: "查看", type: "view" })
      this.uBtnPermissionList.includes('aircraft-modify')&&this.actions.push({ label: "修改", type: "edit" })
      this.uBtnPermissionList.includes('aircraft-delete')&&this.actions.push({ label: "删除", type: "delete" })
      this.getAircraft();
      // this.getOperatorName();
    });
  },
  computed: {
    uBtnPermissionList() {
      return  this.getPageBtnRole('aircraftManagement')||[]
    },
  },
  methods: {
    approvalClick(v){
      this.dialogVisible = true;
      this.dialogTitle = "航空器审批";
      this.btnName = "审批";
      this.ifView = true; //仅查看，不可编辑
      this.taskForm = { ...v };
      this.ifView = true
    },
    rejectClick(v){
      this.$confirm("是否确认驳回", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: '取消',
        type: "warning"
      }).then(()=>{
        this.getRequest(
          "/user-server/Aircraft/refuseById?id=" + v.id,
        ).then((res)=>{
          let oData = res.data;
          if (oData.code === 0) {
            this.$message.success({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
            // 成功后刷新
            this.getAircraft();
          }else {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
        })
      })
    },
    // 关闭对话框时获取子组件传过来的状态
    updateDialogVisible(newVal) {
      this.dialogVisible = newVal;
    },
    //分页函数
    handleSizeChange: function (size) {
      this.size = size;
      this.getAircraft();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.getAircraft();
    },
    getAircraft() {
      this.getRequest("/user-server/Aircraft/queryAllAircraft?current="+ this.current + "&size=" + this.size + "&keyword=" + this.searchKey)
        .then((res) => {
          let oData = res.data;
          console.log(oData)
          if (0 == oData.code) {
            if (oData.data) {
              this.tableData = oData.data.records;
              this.total = oData.data.total;
              this.size = oData.data.size;
              this.current = oData.data.current;
            } else {
              this.tableData = [];
            }
          } else if (oData.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    // 新增 打开弹框，如有下拉选项等数据可在此发请求加载
    addItem() {
      console.log('新增addItem');
      this.dialogVisible = true
      this.dialogTitle = '新增';
      this.btnName = '提交'; //如果是“提交”可不写该行
      this.ifView = false; //可编辑
      this.imageUrl = '';
      this.resetForm();
      this.getOperatorName();
    },
    // 重置表单
    resetForm() {
      this.taskForm = {
        productId: '',
        simpleAircraftName: '',
        verificationMark: '',
        ownerTypeDTO: '',
        ownerName: '',
        manufacturer: '',
        productModel: '',
        productName: '',
        productCategoryDTO: '',
        productTypeDTO: '',
        emptyWeight: '',
        maxLoad: '',
        comDistance: '',
        operatorId: '',
      };
    },
    // 查看
    detailItem(item) {
      console.log('查看--', item)
      this.dialogVisible = true
      this.dialogTitle = '查看';
      this.btnName = '关闭';
      this.ifView = true; //仅查看，不可编辑
      this.taskForm = { ...item };
      this.imageUrl = "/minio/" + item.aircraftPhotoUrl;
      this.imgTitle = '';
      this.getOperatorName();
    },
    // 修改 TODO
    editItem(item) {
      console.log('修改---', item)
      this.dialogVisible = true
      this.dialogTitle = '修改';
      this.btnName = '提交'; //如果是“提交”可不写该行
      this.ifView = false; //可编辑
      this.imageUrl = "/minio/" + item.aircraftPhotoUrl;
      this.taskForm = { ...item };
      this.imgTitle = '单击图片可修改',
      this.getOperatorName();
    },
    // 删除 TODO--
    deleteItem(itemId) {
     try {
        this.deleteRequest(
          "/user-server//Aircraft/deleteAircraftById?id=" + itemId
        ).then((res) => {
           const oData = res.data;
          if  (0 == oData.code) {
            this.$message.success({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
            // 成功后刷新
            this.getAircraft()
          } else {  
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
        });
      } catch (error) {
        console.error("删除失败", error);
      }
    },
    exportItem() {
      this.getRequest("/user-server/Aircraft/queryAllAircraft?current="+ this.current + "&size=" + this.size + "&keyword=" + this.searchKey)

      try {
        axios({
          method: "post",
          // url: `/user-server/Aircraft/exportExcel?current=${this.current}&size=${this.size}&keyword=${this.searchKey}`,
          url: `/user-server/Aircraft/exportExcel?current=1&size=${this.total}&keyword=${this.searchKey}`,
          responseType: "blob"
        }).then(res=>{
          const contentDisposition = res.headers['content-disposition'];
          let filename = contentDisposition.split('filename=')[1];
          if (filename) {
            filename = decodeURIComponent(filename.trim().replace(/"/g, ''));
            filename = filename.replace(/[\/\\:*?"<>|]/g, '_'); // 替换非法字符
          } else {
            filename = '航空器信息.xlsx'; // 设置默认文件名
          }
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
          })
      } catch (error) {
        // console.error('导出失败', error);
        this.$message({
          message: "导出失败",
          duration: 1000,
          customClass: "message-warn-s",
          iconClass: "el-icon-warn-tip",
          offset: 470,
          onClose: function () {},
        });
      }
    },

    // 点击确认
    async handleFormSubmit(formData) {
      // console.log('formData-->', formData)
      // 处理表单提交，根据 dialogTitle 判断是新增还是编辑操作
      if (this.dialogTitle === '新增') {
        // 设置请求头，告诉服务器我们发送的是JSON格式数据
        // const config = {
        //   headers: {
        //     'Content-Type': 'application/json'
        //   }
        // };
        // 执行新增操作 请求后端接口
        const multiData = this.formatSubmitData(deepCopy(formData));
        this.postJsonRequest('/user-server/Aircraft/addAircraft', multiData).then(
        (res) => {
          let oData = res.data;
          if (oData.code === 0) {
            this.$message.success({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
              this.getAircraft();
          } else if (oData.code != 401) {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
        }
      );} else if (this.dialogTitle === '修改') {
      delete formData.updatedTime;
      const multiData = this.formatSubmitData(deepCopy(formData));
      this.putJsonRequest("/user-server/Aircraft/updateAircraft", multiData).then(
        (res) => {
          let oData = res.data;
          if (oData.code === 0) {
            this.$message.success({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
            this.$nextTick(function () {
              this.getAircraft();
            });
          } else if (oData.code != 401) {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
        }
      );

      } else if (this.dialogTitle === '查看') {
        // 执行查看操作
      }else if(this.dialogTitle === "航空器审批"){
        this.getRequest(
          "/user-server//Aircraft/approveById?id=" + formData.id,
        ).then((res) => {
          let oData = res.data;
          if (oData.code === 0) {
            this.$message({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
            });
            // 修改成功后刷新
            this.getAircraft();
          }
        });
      }
      this.dialogVisible = false
    },

    formatSubmitData(commonForms) {
      const formData = new FormData();
      const commonForm = commonForms;
      for (const key in commonForm) {
        if (commonForm.hasOwnProperty(key)) {
          const element = commonForm[key];
          if (null != element && 0 < (element + "").trim().length) {
            formData.append(key, element);
          }
        }
      }
      return formData;
    },

    // 上传图元图片改变时执行的事件
    handleElementPicChange(file) {
      const isJPGPNG = file.type === 'image/jpeg' || 'image/png';
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (!isJPGPNG) {
        let tips = "<i class='el-icon-warn-tip'></i>" + '上传图元图片只能是 JPG 或 png 格式!';
        this.$confirm(tips, "提示", {
          confirmButtonText: "好的",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          showCancelButton: false,
        });
      }
      if (!isLt1M) {
        let tips = "<i class='el-icon-warn-tip'></i>" + '上传图元图片大小不能超过 1MB!';
        this.$confirm(tips, "提示", {
          confirmButtonText: "好的",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          showCancelButton: false,
        });
      }

      if (isJPGPNG && isLt1M) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.taskForm.file = file.raw
      }
    },

    // 获取运营人
    getOperatorName() {
      this.getRequest(
        "/user-server/Operator/queryCoperatorByOperatorName"
      )
        .then(res => {
          let oData = res.data;
          if (0 == oData.code) {
            let nameDataList = oData.data;
            console.log("运营人名称-->", nameDataList);
            this.operatorNames = nameDataList;
          } else if (oData.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch(error => {});
    },
    searchItem(val) {
      //模糊搜索
      // console.log(val);
      this.searchKey = val;
      this.getAircraft();
    },
    // 数字校验 允许小数点
    validateNumber(rule, value, callback) {
      if (value === '' || !/^\d+(\.\d+)?$/.test(value)) {
        callback(new Error('请填写有效的数字'));
      } else {
        callback();
      }
    },
  },
};
</script>
<style scoped>
.upload-demo {
  width: 120px;
  height: 120px;
  /* border: 1px solid #1D6DC8; */
  background: rgba(1,10,18,0.68);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
>>> .el-form-item__label{
  width: 140px !important;
  text-align: right;
}
.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-placeholder .el-icon-upload {
  font-size: 32px;
}

.upload-placeholder .upload-text {
  /* margin-top: 8px; */
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #00aeff;
}
>>>.el-dialog__header {
    /* background-image: url(../../img/common/tableHead.png); */
    /* background-position: 15px 13px;
    background-repeat: no-repeat;
    background-size: 300px 35px; */
    padding: 20px 20px 0px 40px ;
    background: url(../../assets/img/2dmap/pop_bg.png)  no-repeat;
    background-position: 18px 25px;
}
.uploaded-image {
  width: 120px;
  height: 120px;
  object-fit: contain;   /* 保持比例，完整显示，可能有空白 */
  display: flex;        /* 移除底部间隙 */
}
.uploaded-image >>> .el-image__inner {
  max-height: 100% !important;
  max-width: 100% !important;
  object-fit: contain !important;
  height: auto !important; /* 重置默认height */
}
>>> .el-form{
  height: 521px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Aircraft.vue